export default __webpack_public_path__ + "static/media/our-values-Header-2k.5abe4272.jpg";